class ProductSlider extends HTMLElement {
  constructor() {
    super()

    const main = new Splide( '#product-gallery-slider', {
      rewind: true,
      drag: true,
      rewind    : true,
      pagination: false,
      arrows    : false
    });

    const thumbnails = new Splide( '#thumbnail-gallery-slider', {
      fixedWidth  : 75,
      fixedHeight : 75,
      gap         : 12,
      arrows      : true,
      perPage     : 6,
      rewind      : true,
      pagination  : false,
      isNavigation: true,
      breakpoints : {
        750: {
          fixedWidth : 51,
          fixedHeight: 51,
          perPage    : 4,
          gap        : 8,
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    main.on('mounted move', (dest) => {
      const announcement = this.querySelector('.product-slider-announcement');
      if (announcement) {
        announcement.textContent = `Slide ${dest + 1} of ${main.length}`;
      }

      this.mainSlider?.querySelectorAll(`.js-media-main:not([data-index="${dest}"])`)
        .forEach(element => {
          element?.querySelector('video')?.pause()
        })
    })
    thumbnails.mount();
  }

  get mainSlider() {
    return this.querySelector('#product-gallery-slider')
  }
}

customElements.define('product-slider', ProductSlider)
